<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="title-box">
                <div class="tit">{{learn.title}}</div>
                <div class="desc">{{learn.desc}}</div>
            </div>
            <div class="category" style="display: none;">
                <div class="left item" :class="[tab == 1 ? 'active' : '']" @click="setTab(1)">演讲环节</div>
                <div class="left item" :class="[tab == 2 ? 'active' : '']" @click="setTab(2)">展位</div>
                <div class="left item" :class="[tab == 3 ? 'active' : '']" @click="setTab(3)">赞助商</div>
            </div>
            <div class="list-box">
                <div class="box plan-box" :class="[tab == 1 ? 'active' : '']">
                    <div class="item" v-for="(item,index) in session" v-if="item" :class="['item-'+sessionStatus(item,index),item.id == 2 ? 'large' : '',item.id == 3 ? 'large2' : '']">
                        <div class="status" @click="toSession(item,index)">
                            <div class="middle">
                                <div class="icon"></div>
                                <div class="text text-1">会场直播<br/>敬请期待</div>
                                <div class="text text-2">会场直播中</div>
                                <div class="text text-3">会场直播回放</div>
                                <div class="text text-4">即将开始</div>
                            </div>
                        </div>
                        <div class="time-box">
                            <div class="time">
                                <div class="tt">直播时间：</div>
                                <div class="t"><i>{{tool.date.formatDate('H:i',item.live_start)}}-{{tool.date.formatDate('H:i',item.live_end)}}</i></div>
                                <div class="d">{{tool.date.formatDate('Y年m月d日',item.live_start)}} {{week_array[tool.date.formatDate('w',item.live_start)]}}</div>
                            </div>
                            <div class="btn-box" >
                                <div class="btn btn-1" @click="toSession(item,index)">敬请期待</div>
                                <div class="btn btn-2" @click="toSession(item,index)">立即观看</div>
                                <div class="btn btn-3" @click="toSession(item,index)">直播回放</div>
                                <div class="btn btn-4" @click="toSession(item,index)">即将开始</div>
                            </div>
                        </div>
                        <div class="info info-1" v-if="item.id == 7">
                            <div class="middle">
                                <div class="title">领导致辞</div>
                                <div class="topic" style="display: none">
                                    <div class="speaker">
                                        <div class="clear li"><span class="aa">Michael Dell</span><i class="aa">Chairman and CEO Dell Technologies</i></div>
                                        <div class="clear li"><span class="aa">Aongus Hegarty</span><i class="aa">President,International Markets Technologies</i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-1" v-if="item.id == 8">
                            <div class="middle">
                                <div class="title">英特尔助力数字化转型</div>
                                <div class="topic">
                                    <div class="speaker">
                                        <div class="clear li"><span>梁雅莉</span><i class="auto">英特尔公司市场营销集团副总裁 中国区行业解决方案部总经理</i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-1" v-if="item.id == 6">
                            <div class="middle">
                                <div class="title"><sup>Hot</sup>热科技 抢先看</div>
                                <div class="topic">
                                    <div class="speaker">
                                        <div class="clear li"><span>李三平</span><i>戴尔科技集团中国研发集团 首席科学家</i></div>
                                        <div class="clear li"><span>高健</span><i class="auto">戴尔科技集团软件研发总监 PowerStore中国研发团队负责人</i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-1" v-if="item.id == 4">
                            <div class="middle">
                                <div class="title">开场致词—攀登者 中国精神</div>
                                <div class="topic">
                                    <div class="speaker">
                                        <div class="clear li"><span>黄陈宏</span><i>戴尔科技集团大中华区董事长兼总裁</i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-1 midd" v-if="item.id == 1">
                            <div class="middle">
                                <div class="title">高端对话《攀登者》</div>
                                <div class="topic">
                                    <div class="speaker">
                                        <div class="clear li hide"><span>黄陈宏</span><i>戴尔科技集团大中华区董事长兼总裁</i></div>
                                        <div class="clear li"><span>唐维红</span><i>人民网党委委员 监事会主席</i></div>
                                        <div class="clear li"><span>夏伯渝</span><i>中国登山家 电影《攀登者》原型</i></div>
                                        <div class="clear li"><span>许博</span><i>人民网主持人</i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-2" v-if="item.id == 2">
                            <div class="middle">
                                <div class="title">以科技之名，致敬攀登者！</div>
                                <div class="topic">
                                    <div class="ll">
                                        <div class="tit"><i>科技 · 智国</i>新基建—中国经济新动能</div>
                                        <div class="speaker">
                                            <div class="clear li"><span>黄陈宏</span><i>戴尔科技集团大中华区董事长兼总裁</i></div>
                                        </div>
                                    </div>
                                    <div class=" ll">
                                        <div class="tit"><i>科技 · 智造</i>加速从“制造”到“智造”</div>
                                        <div class="speaker">
                                            <div class="clear li hide"><span>潘广崇</span><i>金风科技集团首席转型官</i></div>
                                            <div class="clear li"><span>吴冬梅</span><i>戴尔科技集团全球资深副总裁 中国核心客户和全球客户事业部总经理</i></div>
                                        </div>
                                    </div>
                                    <div class="ll">
                                        <div class="tit"><i>科技 · 智学</i>教育“智能化”是产业趋势</div>
                                        <div class="speaker">
                                            <div class="clear li"><span>应质峰</span><i>复旦大学教务处副处长 创新创业学院副院长</i></div>
                                            <div class="clear li top"><span>陈春曦</span><i>戴尔科技集团中国研发集团 上海公司总经理</i></div>
                                        </div>
                                    </div>
                                    <div class="ll">
                                        <div class="tit"><i>科技 · 智医</i>推进“健康中国”大战略</div>
                                        <div class="speaker">
                                            <div class="clear li"><span>李柏</span><i>全景智联科技有限公司联合创始人、执行总裁</i></div>
                                            <div class="clear li"><span>孔大勇</span><i>戴尔科技集团全球副总裁  大中华区存储平台及解决方案事业部总经理</i></div>
                                        </div>
                                    </div>
                                    <div class="ll large ">
                                        <div class="tit"><i>智能研究基地战略合作揭牌仪式</i></div>
                                        <div class="speaker">
                                            <div class="clear li"><span>程健</span><i>中国科学院自动化研究所人工智能与先进计算联合实验室主任<br/>南京人工智能芯片创新研究院常务副院长</i></div>
                                            <div class="clear li"><span>唐胜宏</span><i>人民网研究院常务副院长</i></div>
                                            <div class="clear li"><span>黄陈宏</span><i>戴尔科技集团大中华区董事长兼总裁</i></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-2" v-if="item.id == 3">
                            <div class="middle">
                                <div class="title">‘在中国 为中国’ 与攀登者共建数字企业</div>
                                <div class="topic">
                                    <div class="ll">
                                        <div class="tit"><i>科技至 · 简</i>新一代信息技术创造“快通道”</div>
                                        <div class="speaker">
                                            <div class="clear li"><span>刘伟</span><i>戴尔科技集团全球副总裁 中国研发集团总经理</i></div>
                                            <div class="clear li"><span>杨捷</span><i>戴尔科技集团高级总监 大中华区售前系统工程部总经理</i></div>
                                        </div>
                                    </div>
                                    <div class="ll">
                                        <div class="tit"><i>科技至 · 新</i>行业转型智能化创新应用</div>
                                        <div class="speaker">
                                            <div class="clear li"><span>孔大勇</span><i>戴尔科技集团全球副总裁 大中华区存储平台及解决方案事业部总经理 </i></div>
                                            <div class="clear li"><span>李三平</span><i>戴尔科技集团中国研发集团 首席科学家</i></div>
                                        </div>
                                    </div>
                                    <div class="ll">
                                        <div class="tit"><i>科技至 · 远</i>构筑可持续发展的技术与实力</div>
                                        <div class="speaker">
                                            <div class="clear li"><span>周兵</span><i>戴尔科技集团全球副总裁 大中华区政府事务部</i></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-1" v-if="item.id == 5">
                            <div class="middle">
                                <div class="title">人民网网友互动问答</div>
                                <div class="topic">
                                    <div class="speaker">
                                        <div class="clear li"><span class="auto">戴尔科技领导代表黄陈宏、周兵、刘伟</span></div>
                                        <div class="clear li"><span class="auto">人民网主持人</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box product-box" :class="[tab == 2 ? 'active' : '']">
                    <div class="left item" @click="toProductDetail(item)" v-for="item in product">
                        <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
                        <div class="element-more tit">{{item.title}}</div>
                        <div class="element-more desc">{{item.min_desc}}</div>
                    </div>
<!--                    <div class="exhibition">-->
<!--                        <img :src="require('@/assets/image/exhibition.jpg')" alt="">-->
<!--                        <div class="link">-->
<!--                            <div class="item" v-for="item in product" @click="util.toLink(item.link,'','_blank')"></div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
                <div class="box dell-sponsor-box" :class="[tab == 3 ? 'active' : '']">
                    <div class="sponsor" v-if="showSponsor(1)">
                        <div class="title">我们的赞助商</div>
                        <div class="line"></div>
                        <div class="list">
                            <div class=" item" v-for="item in sponsor" v-if="item && item.type == 1" @click="toSponsorDetail(item)">
                                <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
                            </div>
                        </div>
                    </div>
                    <div class="sponsor" v-if="showSponsor(2)">
                        <div class="title">特别感谢</div>
                        <div class="line"></div>
                        <div class="list ">
                            <div class=" item" v-for="item in sponsor" v-if="item && item.type == 2" @click="toSponsorDetail(item)">
                                <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
                            </div>
                        </div>
                    </div>
                    <div class="sponsor" v-if="showSponsor(3)">
                        <div class="title">其他赞助商</div>
                        <div class="line"></div>
                        <div class="list list-l">
                            <div class="cen">
                                <div class="left item" v-for="item in sponsor" v-if="item && item.type == 3" @click="toSponsorDetail(item,true)">
                                    <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="data-loading" v-if="show_loading"><loading></loading></div>
        </div>
        <div class="all-mark" v-if="!loaded"></div>
    </main>
</template>

<script>
    import Crumbs from "../../../components/pc/Crumbs";
    import Loading from "../../../components/pc/Loading";
    export default {
        name: 'index',
        data() {
            return {
                loaded:false,
                show_loading:true,
                query:"",
                tab:2,
                learn:{},
                session:[],
                product:[],
                product_link:[
                    {title:"医疗",link:"https://dell.com",},
                    {title:"线上实验室",link:"https://dell.com",},
                    {title:"制造",link:"https://dell.com",},
                    {title:"金融",link:"https://dell.com",},
                    {title:"个人管理",link:"https://dell.com",},
                    {title:"教育",link:"https://dell.com",},
                    {title:"赞助商",link:"https://dell.com",},
                    {title:"5G智慧城市",link:"https://dell.com",},
                    {title:"云和现代化数据中心",link:"https://dell.com",},
                    {title:"现代化工作空间",link:"https://dell.com",},
                    {title:"在中国 为中国",link:"https://dell.com",}
                ],
                sponsor:[],
                page:1,
                service_time:0,

                time_list:[],
                now_time:0
            }
        },
        components:{
            Loading,
            Crumbs
        },
        computed:{
            week_array(){
                return  ["星期日","星期一","星期二","星期三","星期四","星期五","星期六",]
            },
            crumbs() {
				return {title:"联系戴尔",min_title:"CONTACT DELL"}
            },
            form(){
                return {id:1,title:"主会场-大会和主题演讲",list:3,link:"http://dtf.evp.mudu.tv/watch/7r4br30o"}
            }
        },
        watch:{
            '$route' (to, from) {
                if(to.query.type != from.query.type){
                    this.query = this.$route.query;
                    this.getLearn();
                }
            },
            now_time(newVal,oldVal){
                if(newVal > oldVal && this.util.inArray(newVal,this.time_list)){
                    this.getLearnSession();
                }
            }
        },
        methods: {
            toProductDetail(item){
                var url = "/partner/detail?product_id="+item.id;
                this.util.toLink(url);
            },
            toSponsorDetail(item,link=false){
                if(item.show_detail == 2){
                    this.util.toLink(item.link,'','_blank');
                }else{
                    var url = "/sponsor/detail?sponsor_id="+item.id;
                    if(this.$store.state.user_info.id){
                        this.util.toLink(url);
                    }else{
                        this.util.toLink(url);
                    }
                }
            },
            showSponsor(type){
                var flag = false;
                for(var i =0;i<this.sponsor.length;i++){
                    if(this.sponsor[i] && this.sponsor[i].type == type){
                        flag = true;
                    }
                }
                return flag;
            },
            setTab(tab){
                this.tab = tab;
            },
            toSession(item,index){
                var status = this.sessionStatus(item,index);
                if(status == 1){
                    return false;
                }else{
                    var url = this.global.MUDU_HOST +item.live_code;
                    if(this.$store.state.user_info.id){
                        var router = this.$router.resolve({
                            path:"/auth",
                            query:{
                                live_code:item.live_code,
                                redirect:url
                            }
                        });
                        window.open(router.href, '_blank');
                    }else{
                        var from = "/auth?live_code="+item.live_code+"&redirect="+url
                        this.util.showAuth({
                            show:true,
                            from:from
                        });
                    }
                }
            },
            sessionStatus(item,index){
                //return item.live_status;
                var myDate = new Date();
                var now_time = this.service_time;
                if(now_time < parseInt(item.live_start)){
                    if(index == 0){
                        if(now_time < parseInt(item.live_start) - 30*60){
                            return 1;
                        }else{
                            return 4;
                        }
                    }else{
                        return 1;
                    }
                }else if(now_time >= parseInt(item.live_start) && now_time < parseInt(item.live_end)){
                    return 2;
                }else{
                    return 3;
                }
            },
            getLearn(){
                this.show_loading = true;
                this.http.request({
                    api:"learn/getLearn",
                    data:{
                        type:this.query.type,
                    },
                    success:(res)=>{
                        this.learn = res.learn;
                        this.service_time = res.service_time;
                        this.getLearnSession();
                        this.getLearnProduct();
                        this.getLearnSponsor();
                    }
                })
            },
            getLearnProduct(){
                this.http.request({
                    api:"learn/getLearnProduct",
                    data:{
                        learn_id:this.learn.id
                    },
                    success:(res)=>{
                        this.product = res.list;
                    }
                })
            },
            getLearnSession(){
                this.http.request({
                    api:"learn/getLearnTopic",
                    data:{
                        learn_id:this.learn.id
                    },
                    success:(res)=>{
                        this.session = res.list;
                        this.service_time = res.service_time

                        var time_list = [];
                        for(var i =0;i<this.session.length;i++){
                            if(this.session[i]){
                                time_list.push(this.session[i].live_start)
                                time_list.push(this.session[i].live_end)
                            }
                        }
                        this.time_list = time_list;

                        this.show_loading = false;
                        this.$nextTick(()=>{
                            this.loaded = true;
                            this.util.showBottom(true);
                        })
                    }
                })
            },
            getLearnSponsor(){
                this.http.request({
                    api:"learn/getLearnSponsor",
                    data:{
                        learn_id:this.learn.id
                    },
                    success:(res)=>{
                        this.sponsor = res.list;
                    }
                })
            },
            refresh(){
                this.timer = setInterval(()=>{
                    var myDate = new Date();
                    this.now_time = parseInt(myDate.getTime()/1000);
                },1000)
            },
        },
        mounted() {
            this.query = this.$route.query;
            this.getLearn();
            this.refresh();
        },
        destroyed() {
            clearInterval(this.timer);
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{background: #f6f6f6 url("~@/assets/image/2021/17.png") no-repeat bottom center;background-size: 100% auto; padding-top: 20px;
        .title-box{padding:30px;background: #fff;width: 1140px;margin:0 auto;box-shadow:0 0 10px 2px rgba(0,0,0,.1);display: none;
            .tit{font-size: 16px;line-height: 16px;border-left: 4px solid #0176ce;padding-left: 10px;font-weight: bold;}
            .desc{font-size: 13px;margin-top: 10px;line-height: 23px;color:#565656;padding-left: 14px;white-space: pre-line}
        }
        .category{height:50px;margin: 30px auto 0;width: 1200px;background: #fff;box-shadow:0 0 10px 2px rgba(0,0,0,.1);
            .item{padding: 0 20px; height:50px;line-height: 50px;text-align: center;color:#565656;font-size: 16px;transition: all .3s ease;cursor: pointer;}
            .item.active{background: #0176ce;color: #fff;transition: all .3s ease;position: relative}
            .item.active::after{content: "";display: block;width: 0;height: 0;border-left:6px solid transparent;border-right: 6px solid transparent;border-top:6px solid #0176ce;position: absolute;left:50%;margin-left: -6px;bottom:-6px;}
        }
        .list-box{margin:0 auto 0;overflow: hidden;padding: 40px 0 50px;
            .box{display: none;}
            .box.active{display: block}
            .box.product-box{width: 1200px;margin: 0 auto;display: flex;flex-wrap: wrap;
                .item{width: 385px;padding:20px 0;background: #fff;margin-right: 22px;margin-bottom: 20px;border-radius: 5px;cursor: pointer;transition: all .3s ease;
                    .logo{width: 345px;margin:0 auto; height:180px;background: url("~@/assets/image/51.png") no-repeat center center;background-size: cover;}
                    .tit{padding: 0 30px;font-size: 16px;line-height: 23px;margin-top: 10px;}
                    .desc{padding: 0 30px;margin-top:10px;font-size: 13px;color:#929292;line-height: 20px; -webkit-line-clamp:6;white-space: pre-line; }
                }
                .item:nth-child(3n){margin-right: 0;}
                .item:hover{box-shadow: 10px 10px 20px 5px rgba(0,0,0,.1);transition: all .3s ease;}
            }
            .box.plan-box{width: 1200px;margin: 0 auto;
                .item{height:180px; border-radius: 5px;position: relative;margin-bottom: 15px;
                    .status{position: absolute;width: 180px;height:180px;border-radius: 5px;z-index: 3;cursor: pointer;
                        .middle{height:180px;width: 1280px;
                            .icon{height:50px;}
                            .text{line-height: 22px;color:#fff;font-size:20px;text-align: center;padding: 0 10px;margin-top: 10px;display: none;}
                        }
                    }
                    .time-box{position: absolute;width: 220px;padding-left: 180px; height:180px;border-radius: 5px;z-index: 2;background: #eaf7fc;cursor: auto;
                        .time{padding: 20px 25px;
                            .tt{color:#098fc4;font-size: 15px;}
                            .t{color:#098fc4;font-size: 20px;font-weight: bold;margin-top: 3px;}
                            .d{font-size: 14px;color:#929292;font-weight: normal;border-top:1px solid #cbf3fc;margin-top: 5px;padding-top: 5px;}
                        }
                        .btn-box{padding: 0 25px;
                            .btn{width: 140px;height:40px;text-align: center;line-height: 40px;color:#fff;background: #63b4e1;cursor: pointer;transition: all .3s ease;display: none;}
                            .btn.btn-1{background: #b8b8b8;cursor: default}
                            .btn.btn-2{background: #3176c8;}
                            .btn.btn-3{background: #63b4e1;}
                        }
                    }
                    .info{position: absolute;width: 750px;padding: 0 20px 0 430px; height:180px;border-radius: 5px;z-index: 1;background: #fff;cursor: auto;
                        .middle{width: 750px;height:180px;color:#565656;
                            .title{font-size: 16px;font-weight: bold;margin-bottom: 10px;
                                sup{color:red;margin-right: 3px;font-size: 12px;}
                            }
                            .topic{margin-top: 5px;font-size: 14px;
                                .speaker{margin-top: 3px;
                                    .li{line-height: 21px;
                                        span,i{display: block;float: left;}
                                        span{width: 45px;display: inline-block;text-align: justify;text-align-last: justify;}
                                        span.auto{width: 100%;text-align: left;text-align-last:auto;}
                                        span.aa{width: auto; text-align: left;text-align-last:auto;}
                                        i{font-size: 14px;margin-left: 8px;max-width: 285px;}
                                        i.auto{max-width: 100%;}
                                        i.aa{width: auto; max-width: 100%;}
                                    }
                                }
                                .ll{float: right;width: 365px;min-height:83px;margin-bottom: 3px;
                                    .tit{padding-left: 14px;background: url("~@/assets/image/b54.png") no-repeat left center;background-size: 6px;padding-bottom: 2px;
                                        i{font-weight: bold;margin-right: 5px;}
                                    }
                                    .speaker{padding-left: 14px;}
                                }
                                .ll:nth-child(2n+1){width: 365px;margin-right: 10px;float: left;
                                    .speaker{
                                        .li{
                                            i{max-width: 290px;}
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .info.midd{
                        .topic{
                            .speaker{
                                .li{
                                    i{max-width: 400px;}
                                }
                            }
                        }
                    }
                }
                .item.large{height:350px;
                    .status{height:350px;
                        .middle{height:350px;}
                    }
                    .time-box{height:350px;}
                    .info{height:350px;
                        .middle{height:350px;
                            .speaker{
                                .li{line-height: 19px;}
                            }
                        }
                    }
                }
                .item.large2{
                    .info{
                        .middle{
                            .title{margin-top: 10px;}
                            .speaker{
                                .li{line-height: 19px;}
                            }
                        }
                    }
                }
                .item.item-1{
                    .status{background: url("~@/assets/image/39.png") no-repeat center center;background-size: cover;cursor: auto;
                        .middle{
                            .icon{background: url("~@/assets/image/35.png") no-repeat center center;background-size: 49px;}
                            .text-1{display: block;}
                        }
                    }
                    .time-box{
                        .btn-box{
                            .btn-1{display: block;}
                        }
                    }
                }
                .item.item-2{
                    .status{background: url("~@/assets/image/39.png") no-repeat center center;background-size: cover;
                        .middle{
                            .icon{background: url("~@/assets/image/35.png") no-repeat center center;background-size: 49px;}
                            .text-2{display: block;}
                        }
                    }
                    .time-box{
                        .btn-box{
                            .btn-2{display: block;}
                        }
                    }
                }
                .item.item-3{
                    .status{background: url("~@/assets/image/40.png") no-repeat center center;background-size: cover;
                        .middle{
                            .icon{background: url("~@/assets/image/36.png") no-repeat center center;background-size: 49px}
                            .text-3{display: block;}
                        }
                    }
                    .time-box{
                        .btn-box{
                            .btn-3{display: block;}
                        }
                    }
                }
                .item.item-4{
                    .status{background: url("~@/assets/image/39.png") no-repeat center center;background-size: cover;
                        .middle{
                            .icon{background: url("~@/assets/image/35.png") no-repeat center center;background-size: 49px;}
                            .text-4{display: block;}
                        }
                    }
                    .time-box{
                        .btn-box{
                            .btn-4{display: block;}
                        }
                    }
                }
            }
            .box.dell-sponsor-box{
                .sponsor{margin: 30px auto 0;
                    .title{font-size: 28px;text-align: center}
                    .line{width: 230px;height:2px;margin: 2px auto 0; background: url("~@/assets/image/45.png") no-repeat center center;background-size: contain;}
                    .list{width: 1200px; margin: 0 auto;overflow: hidden;padding: 30px 30px 0;
                        .item{background: #fff;cursor: pointer;transition: all .3s ease;margin-bottom: 30px;padding: 30px 0;text-align: center;
                            .logo{width: 200px;height:100px;margin: 0 auto; background: url("~@/assets/image/22.png") no-repeat center center;background-size: contain;}
                        }
                        .item:hover{box-shadow: 0 0 20px 5px rgba(0,0,0,.1);transition: all .3s ease;}
                    }
                    .list.list-l{text-align: center;
                        .cen{display: inline-block;}
                        .item{width: 220px;margin-right: 20px;padding: 30px;margin-bottom: 20px;
                            .logo{width: 140px;height:70px;background: url("~@/assets/image/22.png") no-repeat center center;background-size: contain;}
                        }
                        .item:nth-child(4n){margin-right: 0;}
                    }
                }
            }
        }
    }
    .all-mark{position: fixed;top:0;left:0;width: 100%;height:100%;background: rgba(255,255,255,1);z-index: 1000;}
</style>

